import { faPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useState } from 'react';
import { FormComponent, FormComponentProps } from '../../../../components/form';
import css from './warehouse-select.module.css';
import { useFormContext } from 'react-hook-form';
import Warehouse from '../../../../interfaces/warehouse';

export default function WarehouseSelect(
  warehouse: () => FormComponent[],
  name: string,
  title: string,
  addButtonText: string
): FormComponent {
  return ({ ...rest }) => (
    <WarehouseSelectComponent
      warehouse={warehouse}
      name={name}
      title={title}
      addButtonText={addButtonText}
      {...rest}
    />
  );
}

export function WarehouseSelectComponent({
  warehouse,
  name,
  title,
  addButtonText,
  parentName,
  formValues,
  ...rest
}: FormComponentProps & {
  warehouse: () => FormComponent[];
  name: string;
  title: string;
  addButtonText: string;
  formValues?: object;
}) {
  const { trigger, getValues, setValue } = useFormContext();
  const [state, setState] = useState({
    count: 0,
    components: {} as { [key: string]: FormComponent[] },
  });
  const initialCount = formValues[name]?.length || 1;

  const addWarehouse = useCallback(() => {
    setState((state) => {
      state.components[state.count.toString()] = warehouse();
      return {
        ...state,
        count: state.count + 1,
        components: state.components,
      };
    });
  }, [warehouse]);

  for (let i = state.count; i < initialCount; i++) {
    addWarehouse();
  }

  const removeWarehouse = (rowIndex: string) => {
    setValue(
      'warehouses',
      getValues('warehouses').filter(
        (_warehouse: Warehouse, index: number) => index !== +rowIndex
      )
    );

    trigger('warehouses');

    setState((state) => {
      delete state.components[rowIndex];
      return { ...state };
    });
  };

  return (
    <div className={css['warehouses']}>
      {title && <h3>{title}</h3>}
      {Object.keys(state.components).map((key, index) => (
        <fieldset key={name.concat('-', key)} className={css['warehouse']}>
          <div className={css['body']}>
            <div className={css['remove']}>
              {index > 0 && (
                <button type="button" onClick={() => removeWarehouse(key)}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
            </div>
            <div className={css['components']}>
              {state.components[key].map((Child, index) => {
                return (
                  <Child
                    key={name.concat('-', key, '-', index.toString())}
                    parentName={(parentName
                      ? parentName.concat('.')
                      : ''
                    ).concat(name, '.', key)}
                    {...rest}
                  />
                );
              })}
            </div>
          </div>
        </fieldset>
      ))}
      <div className={css['add']}>
        <button type="button" onClick={addWarehouse}>
          <FontAwesomeIcon icon={faPlus} /> {addButtonText}
        </button>
      </div>
    </div>
  );
}
